<template>
  <div class="tm-app-loader">
    <div
      class="tm-app-loader__content"
      :style="{ width: width }"
    >
      <div
        :class="[
          'tm-app-loader__logo',
          {
            'tm-app-loader__logo--fade-in': !disableFadeIn,
          },
        ]"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="308"
          height="108"
          fill="none"
          viewBox="0 0 308 108"
        >
          <path
            fill="#008CFF"
            fill-rule="evenodd"
            d="M66.771.506H23.792v28.9h5.27v16.607L42.74 29.405h24.03V.505Zm-24.032 28.9 19.368-23.52H29.062v23.52H42.74Z"
            clip-rule="evenodd"
          />
          <path
            fill="#14142B"
            d="M106.197 4.55H82.951v5.47h8.705v26.436h5.836V10.02h8.705V4.55Zm8.705 10.165c-3.283 0-5.926 1.034-7.931 3.099-2.004 2.067-3.008 4.787-3.008 8.16 0 3.371 1.033 6.076 3.098 8.11 2.067 2.036 4.817 3.054 8.249 3.054 3.431 0 6.381-1.26 9.115-3.783l-2.827-4.057c-1.915 1.915-4.009 2.871-6.288 2.871-1.642 0-3-.446-4.079-1.343-1.078-.897-1.695-2.148-1.847-3.76h15.724v-1.093c0-3.587-.897-6.357-2.69-8.317-1.794-1.96-4.299-2.94-7.522-2.94h.006Zm-5.378 8.753c.456-2.827 2.157-4.24 5.106-4.24 1.398 0 2.53.373 3.397 1.118.866.744 1.343 1.784 1.435 3.122h-9.938Zm38.424-8.07h-6.793l-4.009 6.11-3.965-6.11h-6.793l7.385 9.982-8.388 11.076h6.747l5.014-7.11 5.013 7.11h6.792l-8.388-11.076 7.385-9.982Zm117.441.116h-5.592v20.942h5.592V15.514Zm-.095-9.709a3.734 3.734 0 0 0-2.687-1.087 3.72 3.72 0 0 0-2.687 1.087c-.703.703-1.043 1.597-1.043 2.687a3.57 3.57 0 0 0 .235 1.454 3.564 3.564 0 0 0 2.038 2.038c.462.178.959.259 1.454.235 1.09 0 1.987-.336 2.69-1.04a3.644 3.644 0 0 0 1.087-2.69 3.678 3.678 0 0 0-.271-1.453 3.742 3.742 0 0 0-.816-1.234v.003Zm-72.048 8.91c-3.19 0-5.484 1.398-6.881 4.195h-.092c-1.156-2.794-3.313-4.195-6.474-4.195s-5.24 1.293-6.426 3.873h-.092v-3.19h-5.514v21.058h5.562V25.791c0-3.92 1.427-5.88 4.284-5.88 2.523 0 3.783 1.46 3.783 4.376v12.17h5.514V25.743c0-3.888 1.412-5.833 4.239-5.833 2.553 0 3.828 1.46 3.828 4.376v12.17h5.607V23.1c0-2.734-.683-4.817-2.05-6.244-1.367-1.427-3.131-2.142-5.288-2.142Zm28.578 3.647h-.092c-1.46-2.431-3.798-3.647-7.019-3.647-2.886 0-5.293 1.004-7.224 3.01-1.93 2.004-2.895 4.739-2.895 8.203 0 3.465.965 6.2 2.895 8.205 1.931 2.004 4.338 3.008 7.224 3.008 3.221 0 5.562-1.215 7.019-3.646h.092v2.961h5.562V15.398h-5.562v2.964Zm-1.573 11.85c-1.048 1.093-2.422 1.642-4.126 1.642-1.704 0-3.077-.549-4.126-1.642-1.048-1.093-1.573-2.52-1.573-4.284 0-1.763.525-3.19 1.573-4.283 1.049-1.094 2.422-1.642 4.126-1.642 1.704 0 3.078.548 4.126 1.642 1.049 1.093 1.573 2.523 1.573 4.283 0 1.761-.524 3.19-1.573 4.284Zm28.557-11.85h-.092c-1.46-2.431-3.799-3.647-7.019-3.647-2.887 0-5.294 1.004-7.224 3.01-1.93 2.004-2.896 4.739-2.896 8.203 0 3.465.957 6.137 2.872 8.112 1.916 1.975 4.314 2.961 7.2 2.961 3.128 0 5.485-1.167 7.064-3.509h.092v1.96c0 2.068-.396 3.5-1.186 4.308-.789.804-2.142 1.206-4.057 1.206-1.916 0-4.421-.348-7.337-1.048l-1.004 5.332c3.435.667 6.288 1.004 8.567 1.004 3.373 0 5.97-.745 7.793-2.234 1.824-1.49 2.75-4.01 2.78-7.567V15.398h-5.562v2.96l.009.004Zm-1.573 11.85c-1.049 1.093-2.422 1.642-4.126 1.642-1.704 0-3.077-.549-4.126-1.642-1.048-1.093-1.573-2.52-1.573-4.284 0-1.763.525-3.19 1.573-4.283 1.049-1.094 2.422-1.642 4.126-1.642 1.704 0 3.077.548 4.126 1.642 1.049 1.093 1.573 2.523 1.573 4.283 0 1.761-.524 3.19-1.573 4.284Zm34.434 1.686c-1.731 0-3.161-.554-4.284-1.662-1.123-1.108-1.686-2.544-1.686-4.308 0-1.764.563-3.196 1.686-4.308 1.123-1.108 2.553-1.662 4.284-1.662 1.731 0 3.328.486 4.877 1.46l2.416-4.603c-2.249-1.397-4.71-2.097-7.385-2.097-3.435 0-6.229 1.034-8.386 3.098-2.157 2.068-3.235 4.773-3.235 8.112 0 3.34 1.078 6.047 3.235 8.112 2.157 2.067 4.951 3.098 8.386 3.098 2.672 0 5.136-.697 7.385-2.097l-2.416-4.603c-1.549.975-3.176 1.46-4.877 1.46ZM159.393 7.113h-5.592v8.4h-3.875v4.672h3.875v16.271h5.592V20.185h4.308v-4.671h-4.308V7.113Z"
          />

          <circle
            cx="50%"
            cy="83.5"
            r="15.5"
            stroke-width="5"
            stroke="#EBEEF5"
          />

          <circle
            cx="50%"
            cy="83.5"
            r="15.5"
            stroke-width="5"
            stroke="#008CFF"
            stroke-dasharray="0 85.2157007286 12.1736715327"
            stroke-dashoffset="0"
            stroke-linecap="round"
            transform-origin="center 83.5"
          >
            <animate
              attributeName="stroke-dasharray"
              attributeType="XML"
              dur="2400ms"
              repeatCount="indefinite"
              values="0 73.042029196 24.3473430653; 0 24.3473430653 73.042029196; 0 73.042029196 24.3473430653;"
              keyTimes="0; 0.75; 1"
              keySplines="0.5 0 0.5 1; 0.5 0 0.5 1"
              calcMode="spline"
            />

            <animateTransform
              attributeName="transform"
              attributeType="XML"
              type="rotate"
              dur="1200ms"
              repeatCount="indefinite"
              by="360"
            />
          </circle>
        </svg>

        <div class="tm-app-loader__text">
          <div class="tm-app-loader__text--title">
            <slot name="title" />
          </div>

          <div class="tm-app-loader__text--subtitle">
            <slot name="subtitle" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@/composition/vue/compositionApi'

export default defineComponent({
  props: {
    disableFadeIn: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: '320px',
    },
  },
})
</script>

<style lang="scss" scoped>
.tm-app-loader {
  position: fixed;
  z-index: 10;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: $white;
  display: flex;
  align-items: center;
  justify-content: center;

  &__content {
    text-align: center;
  }
}

.tm-app-loader__text {
  margin-top: 20px;
  text-align: center;
  min-height: 100px;

  .tm-app-loader__text--title {
    color: $gray7;
    font-size: $xm-font;
    font-weight: 700;
    line-height: 22px;
    letter-spacing: -0.2px;
  }

  .tm-app-loader__text--subtitle {
    color: $gray6;
    margin-top: 24px;
    font-size: $md-font;
    font-weight: 400;
    line-height: 24px;
  }
}

.tm-app-loader__logo--fade-in {
  opacity: 0;
  animation: loader-logo-appear 600ms ease-in 1ms forwards;
}

@keyframes loader-logo-appear {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}
</style>
